import * as ToastPrimitive from '@radix-ui/react-toast'
import React from 'react'
import styled from 'styled-components'
import { Box, Heading, Image } from '@chatterbug/aaron'
import closeImage from 'src/components/CTAForm/assets/close.svg'

interface ToastProps extends ToastPrimitive.ToastProps {
  title?: string
  content: string
  children?: React.ReactNode
}

const StyledRoot = styled(ToastPrimitive.Root)`
  background-color: white;
  border-radius: 1rem;
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  padding: 15px;
  display: grid;
  grid-template-areas: 'title action' 'description action';
  grid-template-columns: auto max-content;
  column-gap: 15px;
  align-items: center;

  &[data-state='open'] {
    animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1);
  }
  &[data-state='closed'] {
    animation: hide 100ms ease-in;
  }
  &[data-swipe='move'] {
    transform: translateX(var(--radix-toast-swipe-move-x));
  }
  &[data-swipe='cancel'] {
    transform: translateX(0);
    transition: transform 200ms ease-out;
  }
  &[data-swipe='end'] {
    animation: swipeOut 100ms ease-out;
  }
`

const StyledTitle = styled(ToastPrimitive.Title)`
  grid-area: title;
`

const StyledDescription = styled(ToastPrimitive.Description)`
  grid-area: description;
`

const StyledAction = styled(ToastPrimitive.Action)`
  grid-area: action;
`

const StyledClose = styled(ToastPrimitive.Close)`
  appearance: none;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
`

const Toast = ({ title, content, children, ...props }: ToastProps) => {
  return (
    <StyledRoot {...props}>
      {title && (
        <StyledTitle>
          <Heading
            as="h3"
            style={{
              marginTop: '0',
              marginBottom: '0',
            }}
          >
            {title}
          </Heading>
        </StyledTitle>
      )}
      <StyledDescription>
        <Box
          variant="text.paragraph"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </StyledDescription>
      {children && (
        <StyledAction asChild altText="Close">
          {children}
        </StyledAction>
      )}
      <StyledClose aria-label="Close">
        <Image src={closeImage} width="1.5rem" height="1.5rem" />
      </StyledClose>
    </StyledRoot>
  )
}

export { Toast }
